"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  affordance: true,
  breakpoint: 520,
  draggable: true,
  env: 'dev',
  heightInitial: 600,
  heightMax: 800,
  heightMin: 500,
  market: 'en-US',
  position: _constants.POSITION_RIGHT,
  resizable: true,
  shopperId: '',
  showMessaging: false,
  standalone: false,
  tabs: [_constants.TAB_BROWSE, _constants.TAB_CONTACT],
  welcomeIntent: null,
  widthInitial: 352,
  widthMax: 550,
  widthMin: 320,
  zIndex: 2147483647
};
exports.defaultProps = defaultProps;
var propTypes = {
  affordance: _propTypes.default.bool.isRequired,
  breakpoint: _propTypes.default.number.isRequired,
  draggable: _propTypes.default.bool.isRequired,
  env: _propTypes.default.oneOf(_constants.ENVS).isRequired,
  heightInitial: _propTypes.default.number.isRequired,
  heightMax: _propTypes.default.number.isRequired,
  heightMin: _propTypes.default.number.isRequired,
  market: _propTypes.default.string.isRequired,
  position: _propTypes.default.oneOf([_constants.POSITION_LEFT, _constants.POSITION_RIGHT]).isRequired,
  product: _propTypes.default.string,
  resizable: _propTypes.default.bool.isRequired,
  shopperId: _propTypes.default.string.isRequired,
  showMessaging: _propTypes.default.bool,
  standalone: _propTypes.default.bool.isRequired,
  tabInitial: _propTypes.default.oneOf([_constants.TAB_BROWSE, _constants.TAB_CONTACT]),
  tabs: _propTypes.default.arrayOf(function (propValue, key, componentName
  /* , location, propFullName */
  ) {
    if (![_constants.TAB_BROWSE, _constants.TAB_CONTACT].includes(propValue[key])) {
      return new Error("Invalid prop \"".concat(propValue[key], "\" supplied to `").concat(componentName, "`. Validation failed."));
    }
  }),
  welcomeIntent: _propTypes.default.string,
  widthInitial: _propTypes.default.number.isRequired,
  widthMax: _propTypes.default.number.isRequired,
  widthMin: _propTypes.default.number.isRequired,
  zIndex: _propTypes.default.number.isRequired
};
exports.propTypes = propTypes;